import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "documents"
    }}>{`Documents`}</h1>
    <p>{`A collections class allowing for array access into the applications
list of documents that are currently open,
while also providing familiar methods from ExtendScript, like `}<inlineCode parentName="p">{`getByName`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// Iterate through all the documents
app.documents.forEach(h => console.log(h.title));
`}</code></pre>
    <h2 {...{
      "id": "hierarchy"
    }}>{`Hierarchy`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><em parentName="p">{`Array`}</em>{`<`}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/document/"
          }}><em parentName="a">{`Document`}</em></a>{`>`}</p>
        <p parentName="li">{`↳ `}<strong parentName="p">{`Documents`}</strong></p>
      </li>
    </ul>
    <h2 {...{
      "id": "indexable"
    }}>{`Indexable`}</h2>
    <p>{`▪ `}{`[index: `}<em parentName="p">{`number`}</em>{`]`}{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/"
      }}><em parentName="a">{`Document`}</em></a></p>
    <p>{`Used to access the documents in the collection`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// Iterate through all the documents
app.documents.forEach(h => console.log(h.title));
`}</code></pre>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`length`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/document/"
            }}>{`Document`}</a>{` elements in this collection`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/photoshop/"
            }}><em parentName="a">{`Photoshop`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The owner application of this Documents collection`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The name for this object collection: Documents`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "add"
    }}>{`add`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/"
      }}><em parentName="a">{`Document`}</em></a>{`>`}</p>
    <p>{`Create a new document.`}</p>
    <p>{`No options will create a document of 7 x 5 inches at 300 pixels per inch.
This is the same as the "Default Photoshop Size" preset.`}</p>
    <p>{`An object with a 'preset' string parameter can be used to specify any of
the other presets that come installed with Photoshop or created by users.`}</p>
    <p>{`An object with one or more parameters can also be supplied. Any parameter
missing will be set to the default of: width 2100 pixels, height 1500 pixels,
resolution 300 pixels per inch, mode: @RGBColorMode and a fill of white with
no transparency.`}</p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/objects/createoptions/documentcreateoptions/"
            }}><em parentName="a">{`DocumentCreateOptions`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`@DocumentCreateOptions`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "getbyname"
    }}>{`getByName`}</h3>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/"
      }}><em parentName="a">{`Document`}</em></a></p>
    <p>{`Find the first document with the matching name`}</p>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      